// extracted by mini-css-extract-plugin
export var boldText = "_83-4";
export var checkboxContainer = "_83-6";
export var closeIcon = "_83-i";
export var container = "_83-0";
export var drawer = "_83-8";
export var drawerContent = "_83-9";
export var extraSmallText = "_83-5";
export var fulfillmentGroupTable = "_83-e";
export var largeText = "_83-3";
export var loadingSpinnerContainer = "_83-j";
export var mediumText = "_83-2";
export var narrow = "_83-f";
export var notificationLink = "_83-l";
export var packageCheckIconContainer = "_83-7";
export var slideoutHeaderActions = "_83-g";
export var slideoutHeaderActionsShifted = "_83-h";
export var slideoutHeaderContainer = "_83-a";
export var slideoutModal = "_83-c";
export var stickyHeaderWrapper = "_83-b";
export var table = "_83-k";
export var tableContainer = "_83-d";
export var tertiaryText = "_83-1";